import resolveConfig from "tailwindcss/resolveConfig";
// eslint-disable-next-line
const tailwindConfig = require("@axisvue/tailwind-config/tailwind.config");
// Dynamically resolve the tailwind config
function getTailwindConfig() {
    return resolveConfig(tailwindConfig);
}
const resolvedTailwindConfig = getTailwindConfig();
export default resolvedTailwindConfig;
